// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__397ZL","location":"Header_location__iKFYB"};